/**
 * Custom Video Ad (CVAD) Global Script
 * 适配 .btn-overlay-style 类名的跳转按钮
 */

document.addEventListener('DOMContentLoaded', function() {
  initCVAD();
});

// Shopify 主题编辑器支持
if (typeof Shopify === 'object' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    initCVAD();
  });
}

function initCVAD() {
  const containers = document.querySelectorAll('.cvad-container');
  
  if (!containers.length) return;

  containers.forEach(container => {
    // 防止重复初始化
    if (container.dataset.cvadInitialized === 'true') return;
    container.dataset.cvadInitialized = 'true';
    
    const video = container.querySelector('.cvad-video');
    const playBtn = container.querySelector('.cvad-play-btn');
    const pauseBtn = container.querySelector('.cvad-pause-btn');
    // 适配你的按钮类名
    const ctaBtn = container.querySelector('.btn-overlay-style');
    
    const shouldAutoplay = container.dataset.autoplay === 'true';
    
    // 1. 播放按钮点击
    if (playBtn) {
      playBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (video) {
          video.play().then(() => {
            video.muted = false;
            playBtn.style.opacity = '0';
            playBtn.style.pointerEvents = 'none';
            if (pauseBtn) pauseBtn.style.display = 'flex';
            container.classList.add('cvad-playing');
          }).catch(err => console.log('Play error:', err));
        }
      });
    }

    // 2. 暂停按钮点击
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (video) {
          video.pause();
          playBtn.style.opacity = '1';
          playBtn.style.pointerEvents = 'auto';
          pauseBtn.style.display = 'none';
          container.classList.remove('cvad-playing');
        }
      });
    }

    // 3. 点击视频画面切换播放/暂停（排除跳转按钮）
    if (video) {
      video.addEventListener('click', function(e) {
        // 如果点击的是跳转按钮，直接返回，不控制视频
        if (ctaBtn && (e.target === ctaBtn || ctaBtn.contains(e.target))) {
          return;
        }
        
        if (video.paused) {
          video.play();
          video.muted = false;
          if (playBtn) {
            playBtn.style.opacity = '0';
            playBtn.style.pointerEvents = 'none';
          }
          if (pauseBtn) pauseBtn.style.display = 'flex';
          container.classList.add('cvad-playing');
        } else {
          video.pause();
          if (playBtn) {
            playBtn.style.opacity = '1';
            playBtn.style.pointerEvents = 'auto';
          }
          if (pauseBtn) pauseBtn.style.display = 'none';
          container.classList.remove('cvad-playing');
        }
      });
    }

    // 4. 视频播放结束重置
    if (video) {
      video.addEventListener('ended', function() {
        if (playBtn) {
          playBtn.style.opacity = '1';
          playBtn.style.pointerEvents = 'auto';
        }
        if (pauseBtn) pauseBtn.style.display = 'none';
        container.classList.remove('cvad-playing');
      });
    }
    
    // 5. 自动播放逻辑
    if (shouldAutoplay && video) {
      video.muted = true;
      video.play().then(() => {
        if (playBtn) {
          playBtn.style.opacity = '0';
          playBtn.style.pointerEvents = 'none';
        }
        if (pauseBtn) pauseBtn.style.display = 'flex';
        container.classList.add('cvad-playing');
      }).catch(err => console.log('Auto-play prevented:', err));
    }
  });
}